// start:ng42.barrel
export * from './common-pipes.module';
export * from './moment-date.pipe';
export * from './truncate.pipe';
// end:ng42.barrel

